import { createContext } from "react";

export const SelectPortContext = createContext(null);
